import { IconDownload, IconX } from '@tabler/icons-react';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import IconButton from '../../../components/Buttons/IconButton';

const BusinessCardQrViewModal = ({ qrLink }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            <img className='h-16 cursor-pointer' src={qrLink} alt="" onClick={handleShow} />

            <Modal show={show} onHide={handleClose} >
                <Modal.Body className='rounded-xl text-center'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold">View QR</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <img className='h-[250px] mx-auto' src={qrLink} alt="" />
                    <div className='my-3'> <a href={qrLink} className='no-underline w-max'> <IconButton cssClass={'mx-auto'} text={'Download QR'} icon={< IconDownload size={16} />} /></a></div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default BusinessCardQrViewModal